import CheckIcon from '@mui/icons-material/Check';
import React, { useEffect, useRef, useState } from 'react';
import { SyncLoader } from 'react-spinners';

interface VyTextAreaProps extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  maxLength?: number;
  fullWidth?: boolean;
  loading?: boolean;
  variant?: 'small' | 'medium' | 'large';
}

const VyTextArea = React.forwardRef<HTMLTextAreaElement, VyTextAreaProps>((props: VyTextAreaProps, ref) => {
  const [value, setValue] = useState<string>(props.defaultValue?.toString() || '');
  const [loadingDone, setLoadingDone] = useState<boolean>(false);

  function paddingSize(variant: string | undefined) {
    switch (variant) {
      case 'small':
        return 0;
      case 'medium':
        return 8;
      case 'large':
        return 14;
      default:
        return 0;
    }
  }

  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (!props.loading) {
      setLoadingDone(true);
      setTimeout(function () {
        setLoadingDone(false);
      }, 400);
    }
  }, [props.loading]);

  return (
    <>
      <div className={`${props.fullWidth ? 'w-full' : ''} container inline-block relative mt-3 `}>
        <p className={`duration-500 opacity-${value.length ? 1 : 0} bg-white absolute top-[-10px] left-[5px] text-slate-500 text-xs`}>{props.placeholder}</p>
        <textarea
          {...props}
          onChange={(e) => {
            props.onChange?.(e);
            setValue(e.target.value);
          }}
          className={`${props.className} ${props.fullWidth ? 'w-full' : ''} rounded outline-none p-0.5 duration-${
            loadingDone ? '200' : '500'
          } w-full resize-none align-top box-border bg-[#f7fafc] focus:border-vystemblue`}
          style={{ padding: `${paddingSize(props.variant)}px`, border: loadingDone ? '1px solid rgba(63, 232, 99, 1)' : '1px solid rgba(0, 0, 0, 0.11)' }}
          ref={ref}>
          {props.children}
        </textarea>
        <div
          className={`absolute top-[-2px] right-[${props.loading ? '-15px' : '0px'}] text-xs scale-[0.3] duration-500 transition-opacity opacity-${
            props.loading ? '1' : '0'
          }`}>
          {!loadingDone || props.loading ? <SyncLoader color="grey" /> : <CheckIcon htmlColor="rgba(0, 0, 0, 1)" />}
        </div>
        {props.maxLength ? (
          <small className="absolute bottom-[3px] right-[5px] text-xs text-slate-500">{`${value?.length || 0} / ${props.maxLength}`}</small>
        ) : null}
      </div>
    </>
  );
});

export default VyTextArea;
